"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
function SectionPanel(props) {
  var header = props.header,
    subHeader = props.subHeader,
    _a = props.className,
    className = _a === void 0 ? '' : _a;
  return react_1.default.createElement(PanelWrapper, {
    className: className
  }, react_1.default.createElement("div", {
    className: "header"
  }, react_1.default.createElement("h2", null, header), subHeader && react_1.default.createElement("div", null, subHeader)), react_1.default.createElement("div", {
    className: "content"
  }, props.children));
}
var PanelWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 20px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 0px 0px rgba(0,0,0,0.1);\n  transition: all 200ms;\n\n  &:hover {\n    box-shadow: 0 2px 5px rgba(0,0,0,0.4);\n  }\n\n  & > div.header {\n    display: flex;\n    align-items: ceneter;\n    padding: 8px 15px;\n    background-color: #eee;\n\n    & > h2 {\n      flex: 1;\n      font-size: 1.2rem;\n      font-weight: 500;\n    }\n\n    & > div {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  & > div.content {\n    border-top: 1px solid #ccc;\n    padding: 8px 15px;\n    background-color: white;\n  }\n}\n"], ["\n  margin-bottom: 20px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 0px 0px rgba(0,0,0,0.1);\n  transition: all 200ms;\n\n  &:hover {\n    box-shadow: 0 2px 5px rgba(0,0,0,0.4);\n  }\n\n  & > div.header {\n    display: flex;\n    align-items: ceneter;\n    padding: 8px 15px;\n    background-color: #eee;\n\n    & > h2 {\n      flex: 1;\n      font-size: 1.2rem;\n      font-weight: 500;\n    }\n\n    & > div {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  & > div.content {\n    border-top: 1px solid #ccc;\n    padding: 8px 15px;\n    background-color: white;\n  }\n}\n"])));
exports.default = SectionPanel;
var templateObject_1;